import type { Action } from '@ardoq/rxbeach';
import { isTruthy } from '@ardoq/common-helpers';
import {
  uploadFileNamesDuplicated,
  uploadFilesTooLarge,
  type UploadFilesPayload,
} from './actions';

export const MAX_FILE_SIZE = 20 * 1024 * 1024; // 20 MB

export const MaxFileSizeMB = MAX_FILE_SIZE / (1024 * 1024);

export const areFileSizesValid = (files: File[] = []): boolean =>
  !files.some(file => file.size > MAX_FILE_SIZE);

const toFileNames = (files: File[]): string =>
  files.map(file => file.name).join(', ');

export const toUploadFilesRejections = ({
  files,
  existingAttachmentNames,
}: UploadFilesPayload): Action<unknown>[] => {
  const tooLarge = files.filter(file => file.size > MAX_FILE_SIZE);
  const duplicates = files.filter(file =>
    existingAttachmentNames.includes(file.name)
  );
  return [
    tooLarge.length > 0 &&
      uploadFilesTooLarge({
        fileNames: toFileNames(tooLarge),
        maxFileSizeMb: MaxFileSizeMB,
      }),
    duplicates.length > 0 &&
      uploadFileNamesDuplicated({ fileNames: toFileNames(duplicates) }),
  ].filter(isTruthy);
};
